<template lang="pug">
.content-wrap
	.content-top
		.con
			.conbox
				.follow-wrapper
					.fubox-wrapper
						.ll(v-if="socialList.length>0")
							template(v-if="item.social_link !='' && item.social_link !=null" v-for="item in socialList" )
								.fubos.fb(v-if="item.social_platform ==='facebook'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/fb.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin
								.fubos.yt(v-if="item.social_platform ==='youtube'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/yt.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin
								.fubos.ig(v-if="item.social_platform ==='instagram'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/ig.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span @epicwin
								.fubos.tl(v-if="item.social_platform ==='telegram'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/tl.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin
								.fubos.tp(v-if="item.social_platform ==='trustpilot'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/tp.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span Epicvipclub 
								.fubos.wa(v-if="item.social_platform ==='whatsapp'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/wa.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin
								.fubos.wa(v-if="item.social_platform ==='joylink'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/joylink.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWinVVIP
						//- .rr
							img.floating(src='/new/img/contact/jake.png')
			footerInfo(:target="'/review'")
</template>
<script>
import config from "@/config";
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
	components:{
		footerInfo
	},
	data(){
		return{
			feedback: {
        success: true,
        status: ""
      },
			loading:false,
			// socialList: [],
			imgUrl: config.imageUrl,
		}
	},
	computed:{
		socialList(){
			return this.$store.getters.getSocialList
		}
	},
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/followUs`);
		// this.getSeo("contactUs")
	},
	mounted(){
    window.scroll(0, 0)
		// this.getSocialList()
	},
	methods:{
		getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
		// getSocialList(){
		// 	this.$store
		// 		.dispatch("user/getSocialList", { })
		// 		.then(response => {
		// 			if (response.success == true) {
		// 				this.socialList = response.data.value
		// 			} else {
		// 				if((typeof response.status) != 'object'){
		// 					this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
		// 				}
		// 			}
		// 		})
		// 		.catch(response => {
		// 			if((typeof response.status) != 'object'){
		// 				this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
		// 			}
		// 		});
		// }
	}
}
</script>